import { useMarkToolbarButton, useMarkToolbarButtonState } from "platejs/react";
import { type JSXElementConstructor, memo } from "react";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { ToolbarButton } from "./toolbar";
import { useToolbarOverflow } from "./toolbar-overflow";

export interface MarkToolbarButtonProps {
  nodeType: string;
  tooltip: string;
  clear?: string | string[];
  Icon: JSXElementConstructor<object>;
}

export const MarkToolbarButton = memo(function MarkToolbarButton({
  nodeType,
  tooltip,
  clear,
  Icon,
}: MarkToolbarButtonProps) {
  const state = useMarkToolbarButtonState({ clear, nodeType });
  const { props } = useMarkToolbarButton(state);
  const { isOverflow } = useToolbarOverflow();

  if (isOverflow) {
    const label = tooltip.replace(/\s*\(.*\)$/, "");
    return (
      <DropdownMenuItem onSelect={props.onClick as () => void}>
        <Icon />
        {label}
      </DropdownMenuItem>
    );
  }

  return (
    <ToolbarButton
      Icon={Icon}
      onClick={props.onClick}
      pressed={props.pressed}
      tooltip={tooltip}
    />
  );
});
